import {setProductWidth} from "../utils/set-product-width";

const MARGIN: number = 30;
const PERCENTAGE: number = 75;
const BASE_PERCENTAGE: number = 100;

export const productAdditionalPriceTextBaseStyles = {
    "& .price-additional-text": {
        fontSize: ({fonts}) => fonts.baseSize * PERCENTAGE / BASE_PERCENTAGE,
        fontWeight: "normal",
        display: "inline-flex",
        flexDirection: "row",
        "&.is-reversed": {
            "& .price-complementary-column-value": {
                order: "-1"
            }
        },
        "& .price-complementary-text-value, & .price-complementary-column-value": {
            display: "inline-block",
            margin: "0 2px"
        },
        "&.price-additional-text--top, &.price-additional-text--bottom": {
            display: "flex",
            "&.price-additional-text--hidden": {
                visibility: "hidden", // keep space for vertical positioned elements
            },
        },
        "&.price-additional-text--right, &.price-additional-text--left": {
            "&.price-additional-text--hidden": {
                display: "none",
            },
        },
    },
};

export const productRecommendationBaseStyles = (globals): Record<string, unknown> => ({
    width: ({recommendationSettings}) => setProductWidth(recommendationSettings.numberOfProductsPerResultsRow, MARGIN),
    marginBottom: "30px",
    marginRight: "15px",
    marginLeft: "15px",
    alignItems: "flex-start",
    [`@media (${globals.breakpoints.$sm})`]: {
        width: "calc(50% - 30px)",
    },
    [`@media (${globals.breakpoints.$xs})`]: {
        width: "100%",
        marginRight: 0,
        marginLeft: 0,
    },
    ...productAdditionalPriceTextBaseStyles
});
